import React from "react";
import { Card, Container, Row, Col, Carousel } from "react-bootstrap";

const Clients = () => {
  const industries = [
    {
      icon: (
        <img src="/assets/Avatar1.png" alt="Healthcare" className="img-fluid" />
      ),
      title: "Olivia Rhye",
      review: "Marketing Agency Owner",
      reviewer:
        "Nouraa has transformed how we handle client communications. The 24/7 support has been invaluable for our business growth.",
    },
    {
      icon: (
        <img src="/assets/Avatar2.png" alt="Law Firms" className="img-fluid" />
      ),
      title: "Micheal Chen",
      review: "Law Firm Partner",
      reviewer:
        "The lead screening feature has helped us focus on qualified clients while maintaining professional communication standards.",
    },
    {
      icon: (
        <img
          src="/assets/Avatar3.png"
          alt="Home Services"
          className="img-fluid"
        />
      ),
      title: "Drew Cano",
      review: "Healthcare Provider",
      reviewer:
        "The appointment scheduling system is seamless and has significantly reduced our administrative workload.",
    },
    {
      icon: (
        <img src="/assets/client1.jpg" alt="Retail" className="img-fluid" />
      ),
      title: "Jane Doe",
      review: "Retail Store Owner",
      reviewer:
        "Nouraa's customer service automation has improved our response times and customer satisfaction.",
    },
    {
      icon: (
        <img src="/assets/client2.png" alt="Finance" className="img-fluid" />
      ),
      title: "John Smith",
      review: "Finance Advisor",
      reviewer:
        "The call recording feature has been a game-changer for compliance and training purposes.",
    },
    {
      icon: (
        <img src="/assets/client3.jpg" alt="Finance" className="img-fluid" />
      ),
      title: "Lima Lon",
      review: "Security Advisor",
      reviewer:
        "The call recording feature has significantly improved our compliance and training processes, making everything more efficient.",
    },
  ];

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const industryChunks = chunkArray(industries, 3);

  return (
    <div className="container-fluid body-font py-5">
      <Container>
        <h1 className="text-center fs-four-title anybody-font fw-bold my-5">
          Hear from Our Happy Clients
        </h1>
        <Carousel
          nextIcon={
            <img
              src="/assets/arrow-right-carousel.svg"
              alt="Next"
              className="carousel-arrow next p-2"
            />
          }
          prevIcon={
            <img
              src="/assets/arrow-left-carousel.svg"
              alt="Previous"
              className="carousel-arrow prev p-2"
            />
          }
          className="clients-carousel"
        >
          {industryChunks.map((chunk, index) => (
            <Carousel.Item key={index}>
              <Row className="justify-content-center py-4 px-2">
                {chunk.map((industry, idx) => (
                  <Col md={4} key={idx}>
                    <Card className="h-100 text-start p-4 rounded-3 shadow border-0">
                      <Card.Body>
                        <div className="d-flex align-items-center mb-3">
                          <div className="me-4">{industry.icon}</div>
                          <div>
                            <Card.Title className="fs-three fw-bold">
                              {industry.title}
                            </Card.Title>
                            <Card.Text className="mb-2 reviewer-name">
                              {industry.review}
                            </Card.Text>
                          </div>
                        </div>
                        <Card.Text className="gray-color">
                          "{industry.reviewer}"
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </div>
  );
};

export default Clients;
